<template>
  <div>
    <h5>{{photoMeta.display}}</h5>
    <div class="md-layout">
      <div style="min-width: 640px">
        <div v-if="newPhoto">
          <canvas width="640" height="480"/>
        </div>
        <div v-else>
          <div v-if="photo" class="ccic-photo-placeholder">
            <img width="640" height="480" :src="photo.photoUrl"/>
          </div>
          <div v-else class="ccic-photo-placeholder">
            No Photo
          </div>
        </div>
      </div>
      <div style="width: 160px">
        <div v-if="newPhoto">
          <md-field>
            <label>Timestamp</label>
            <md-input v-model="newPhoto.refTimeStamp"/>
          </md-field>
          <calling-api path="/api/w/ccic/photo/save">
            <div>
              <md-button class="md-primary md-raised" @click="doSavePhoto">Save</md-button>
            </div>
            <div>
              <md-button class="md-raised" @click="doCancel">Cancel</md-button>
            </div>
          </calling-api>
        </div>
        <div v-else>
          <div v-if="photoMeta.key != 'BWT1'">
             <md-button :disabled="!savePhotoButton" class="md-primary md-raised" @click="toggleUpload">Upload</md-button>
             <input type="file" class="md-hide upload-ccic-photo" accept=".png,.jpg,.jpeg" @change="handleImageFileSelected"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

  .ccic-photo-placeholder {
    min-width: 640px;
    min-height: 480px;
    background-color: #e3e3e3;
  }

</style>

<script>

  export default {
    props: {
      photoMeta: Object,
      photo: Object,
      doPhotoUpload: Function,
      savePhotoButton: Boolean,
    },
    data: () => ({
      newPhoto: null,
      img: null,
    }),
    watch: {
      'newPhoto.refTimeStamp': {
        handler(val) {
          this.renderPhoto();
        },
        deep: true,
      },
      img() {
        this.renderPhoto();
      },
    },
    computed: {},
    methods: {
      toggleUpload() {
        this.$el.querySelector('.upload-ccic-photo')
          .click();
      },
      handleImageFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          const file = files[0];
          this.newPhoto = {
            refTimeStamp: moment()
              .format("MM/DD/YYYY"),
            photoKey: this.photoMeta.key,
            image: {
              fileName: this.photoMeta.fileName,
              imageBase64: '',
              folder: '',
            },
          };
          this.$nextTick(() => {
            const canvas = this.$el.querySelector('canvas');
            const ctx = canvas.getContext("2d");
            const img = document.createElement("img");

            img.onload = () => {
              this.img = img;
            };

            const reader = new FileReader();
            reader.onload = (e) => {
              img.src = e.target.result;
            };
            reader.readAsDataURL(file);
            ctx.drawImage(img, 0, 0);
          });
        }
      },
      renderPhoto() {
        const canvas = this.$el.querySelector('canvas');
        if (canvas == null) {
          return;
        }
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (this.newPhoto && this.newPhoto.refTimeStamp && this.img) {
          ctx.drawImage(this.img, 0, 0, 640, 480);
          ctx.font = "24px Comic Sans MS";
          ctx.fillStyle = "white";
          ctx.textAlign = "center";
          ctx.fillText(this.newPhoto.refTimeStamp, canvas.width - 100, canvas.height - 30);

          const base64 = canvas.toDataURL("image/jpeg")
            .replace("data:image/jpeg;base64,", "");
          this.newPhoto.image.imageBase64 = base64;
        }
      },
      doCancel() {
        this.newPhoto = null;
        this.img = null;
      },
      async doSavePhoto() {
        await this.doPhotoUpload(this.newPhoto);
        this.doCancel();
      },
    },

  };

</script>
